<template>
  <v-card :loading="loading" flat>
    <v-card-title class="pb-5">
      <v-btn :loading="loading" class="submit-btn" @click="addPack">
        <span class="fa fa-bookmark icon-md ml-1"></span>
        ذخیره
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
            v-model="title"
            :error-messages="errors.name"
            dense
            label="عنوان لاتین"
            outlined
            required
          />
        </v-flex>

        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <v-text-field
            v-model="title_fa"
            :error-messages="errors.name_fa"
            dense
            label="نام فارسی"
            outlined
            required
          />
        </v-flex>

        <v-flex class="p-2" lg6 md6 sm12 xl6 xs12>
          <permission-picker
            v-model="permissions"
            :errors="errors.permissions_id"
            :selectedPermissions="selectedPermissions"
          />
        </v-flex>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";

export default {
  components: { smsTariffPicker, priceInput, subLinePicker, permissionPicker },
  data() {
    return {
      service: [],
      services: [],
      title: null,
      title_fa: "",
      expire: null,
      permissions: {},
      selectedPermissions: {},
      tariff: {},
      subline: {},
      tariffs: [],
      owner: { id: null },
      owners: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      show: { id: null },
      shows: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      role: { id: null },
      roles: [],
      errors: [],
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        permissions: [
          (val) => (val || []).length > 0 || "فیلد دسترسی الزامی می باشد.",
        ],
      },
      loading: false,
    };
  },

  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: tihs.$t(this.$route.meta.title) },
    ]);
  },

  mounted() {
    this.fetchIndexData();
    this.getRoles();
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("PermissionsIndex", ["data", "total", "loading"]),

    config() {
      return this.layoutConfig();
    },
  },

  watch: {
    query: {
      handler(query) {
        this.setQuery(query);
        this.fetchIndexData();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions("PermissionsIndex", [
      "fetchIndexData",
      "setQuery",
      "resetState",
    ]),

    addPack() {
      this.loading = true;

      let checkedPermission = [];
      for (let a in this.permissions) {
        checkedPermission.push(a);
      }

      this.requestApiPost("admin/roles", {
        name: this.title,
        name_fa: this.title_fa,
        permissions_id: checkedPermission,
        permissionStatus: this.selectedPermissions,
      })
        .then((response) => {
          this.$toast.success("نقش جدید با موفقیت ایجاد شد.");
          this.$router.push({ name: "roles.index" });
          this.loading = false;
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response.data.errors;
        });
    },

    getRoles() {
      this.requestApiGet("admin/roles").then((response) => {
        this.roles = response.data.data;
      });
    },
  },
};
</script>
